import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateCollectionOrderMutation = createMutationHook(
  CollectionsApiClient.updateCollectionOrder,
  {
    mutationKey: ['updateCollectionOrder'],
  },
)
